import { Currency } from '@seapoint/server/enums';
import euFlag from '../assets/images/flag-eu.svg';
import gbFlag from '../assets/images/flag-gb.svg';
import { SupportedCountryCurrency } from '../types/supported-country-currency';
import { exhaustiveCheck } from './exhaustive-check';

// TODO: merge with get-currency-flag.ts
export const getCurrencyDetails = (currency: SupportedCountryCurrency) => {
  switch (currency) {
    case Currency.EUR:
      return {
        flag: euFlag,
        name: 'Euro',
        plural: 'Euros',
      };
    case Currency.GBP:
      return {
        flag: gbFlag,
        name: 'GB Pound',
        plural: 'Pounds',
      };
    default:
      return exhaustiveCheck(currency);
  }
};
